export default "__VITE_ASSET__DY1$xgDB__"